import React from 'react'
import { PreCacheItem, PrecacheItemType, SinglePreCacheItem } from '../../cvp-webgames-core/pre-caching/pre-cache-item';
import { BaseConfig } from '../BaseConfig';
import Button1 from '../general/button1';
import { UIProperties } from '../../cvp-webgames-core/Components/ui/UIProperties';

import "./skip-content-ui.css"
import { constants } from '../../misc/constants';
import Tools from '../../cvp-webgames-core/Misc/Tools';

class SkipContentUICaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'skip',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/skip.svg'
			}
		];
	}
}

export const skipContentUICaching = new SkipContentUICaching();

const SkipContentUI = (props: UIProperties<SkipContentUIConfig>) => {
	return (
		<div className="modal-disable-select skip-content-ui-container" style={Tools.isios() ? {
			bottom: '180px'
		} : {}}>
			<Button1 props={{
				width: '100%',
				height: '100%',
				hoverColor: constants.design.hoverColor2,
				onClick: props.parameters.onSkipContentClicked,
				buttonText: 'Skip Content',
				imgSrc: skipContentUICaching.getItemByKey('skip').src,
				alt508: '',
				imgOnRight: true,
				imgWidth: '8%',
				imgRight: '50px',
				imgTextLeft: '-25px',
				customClass: constants.mainContent508Id
			}} ></Button1>
		</div>
	);

};

export interface SkipContentUIConfig extends BaseConfig {
	onSkipContentClicked: () => void;
}

export default SkipContentUI;